import { PAGE_TYPE } from "@supplier/meta";
import { RouteRecordRaw } from "vue-router";

const purchasingRouter: RouteRecordRaw[] = [
    {
        path: "purchasingManage",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/purchasingManage/order",
        name: "PurchasingManage",
        meta: {
            title: "采购管理"
        },
        children: [
            {
                path: "order",
                name: "PurchaseOrderManagement",
                component: () => import("@/views/pages/purchasingManage/orderManagement/index.vue"),
                meta: {
                    title: "订单管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "order/add",
                name: "PurchaseOrderAdd",
                component: () => import("@/views/pages/purchasingManage/orderManagement/form.vue"),
                meta: {
                    title: "新增订单",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "PurchaseOrderManagement",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "order/edit/:id",
                name: "PurchaseOrderEdit",
                component: () => import("@/views/pages/purchasingManage/orderManagement/form.vue"),
                meta: {
                    title: "修改订单",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "PurchaseOrderManagement",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "order/:id",
                name: "PurchaseOrderInfo",
                component: () => import("@/views/pages/purchasingManage/orderManagement/details.vue"),
                meta: {
                    title: "订单详情",
                    hidden: true,
                    customize: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    activeMenu: "PurchaseOrderManagement",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        }
                    ],
                    isNotShowHeader: true
                }
            },

            {
                path: "delivery",
                name: "PurchaseDelivery",
                meta: {
                    title: "提货管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                },
                component: () => import("@/views/pages/purchasingManage/deliveryManagement/index.vue")
            },
            {
                path: "delivery/add",
                name: "PurchaseDeliveryAdd",
                component: () => import("@/views/pages/purchasingManage/deliveryManagement/form.vue"),
                meta: {
                    title: "新增提货",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "PurchaseDelivery",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "delivery/edit/:id",
                name: "PurchaseDeliveryEdit",
                component: () => import("@/views/pages/purchasingManage/deliveryManagement/form.vue"),
                meta: {
                    title: "修改提货",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "PurchaseDelivery",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "delivery/:id",
                name: "PurchaseDeliveryInfo",
                component: () => import("@/views/pages/purchasingManage/deliveryManagement/details.vue"),
                meta: {
                    title: "提货详情",
                    hidden: true,
                    customize: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    activeMenu: "PurchaseDelivery",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ],
                    isNotShowHeader: true
                }
            },
            {
                path: "receipt",
                name: "PurchaseReceipt",
                component: () => import("@/views/pages/purchasingManage/receiptManagement/index.vue"),
                meta: {
                    title: "签收管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "receipt/add",
                name: "PurchaseReceiptAdd",
                component: () => import("@/views/pages/purchasingManage/receiptManagement/form/index.vue"),
                meta: {
                    title: "新增签收",
                    activeMenu: "PurchaseReceipt",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "receipt/edit/:id",
                name: "PurchaseReceiptEdit",
                component: () => import("@/views/pages/purchasingManage/receiptManagement/form/index.vue"),
                meta: {
                    title: "修改签收",
                    activeMenu: "PurchaseReceipt",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "receipt/detail/:id",
                name: "PurchaseReceiptInfo",
                component: () => import("@/views/pages/purchasingManage/receiptManagement/detail.vue"),
                meta: {
                    title: "签收详情",
                    activeMenu: "PurchaseReceipt",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "reconciliation",
                name: "PurchaseReconciliation",
                component: () => import("@/views/pages/purchasingManage/reconciliation/index.vue"),
                meta: {
                    title: "结算管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "reconciliation/add",
                name: "PurchaseReconciliationAdd",
                component: () => import("@/views/pages/purchasingManage/reconciliation/form.vue"),
                meta: {
                    title: "新增结算",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "PurchaseReconciliation",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "reconciliation/edit/:id",
                name: "PurchaseReconciliationEdit",
                component: () => import("@/views/pages/purchasingManage/reconciliation/form.vue"),
                meta: {
                    title: "修改结算",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "PurchaseReconciliation",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "reconciliation/:id",
                name: "PurchaseReconciliationInfo",
                component: () => import("@/views/pages/purchasingManage/reconciliation/details.vue"),
                meta: {
                    title: "结算详情",
                    hidden: true,
                    customize: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    activeMenu: "PurchaseReconciliation",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        }
                    ],
                    isNotShowHeader: true
                }
            }
        ]
    }
];

export default purchasingRouter;
